/* eslint-disable import/prefer-default-export */
import { application } from '../../../core/backbone'

import microFrontendProduction from './hub'

import {
  rbac,
  name,
  version,
  events,
  publicPath,
  environment,
  mfeDependencies,
} from 'front-hub-application-host-configuration-prod'

import frontHubServiceConfiguration from 'front-hub-service-configuration'
import { changeVirtualPath } from 'front-hub-context-api'
import { setup as setupServices } from '../../../core/services'
import FronthubError from '../../../core/helpers/FronthubError'
import isFunction from '../../../core/helpers/isFunction'

const microfrontend = application()

const Connect = (Component, addon = {}) => {
  if (!isFunction(microfrontend.connect)) {
    throw new FronthubError(
      'private connect function was not defined before public Connect call',
    )
  }
  return microfrontend.connect(fronthubContext => {
    const configuration = fronthubContext?.configuration || {}
    configuration.rbac = rbac
    configuration.events = events
    configuration.name = name
    configuration.version = version
    configuration.environment = environment
    configuration.mfeDependencies = mfeDependencies

    setupServices(frontHubServiceConfiguration, environment)

    isFunction(publicPath) && changeVirtualPath(publicPath(configuration))
    return microFrontendProduction(Component, fronthubContext, addon)
  })
}

export default Connect
